/**
 * Parses a Tree: the Control base plus `columns`/`column_titles_visible`. Rows never serialise,
 * since `TreeItem` is not a `Node` (`scene/gui/tree.h`), and column titles have no property
 * (`tree.cpp:6807-6823` is the whole list), so both are script-only and a header row draws blank.
 */
import { parseOptionalBool, parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
export function parseTree(heading, properties) {
    return {
        ...parseControl(heading, properties),
        columns: parseOptionalInt(properties.columns),
        columnTitlesVisible: parseOptionalBool(properties.column_titles_visible),
    };
}
//# sourceMappingURL=parser.js.map